import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase/config";
import { normalizeCategory, normalizeProduct } from "../../firebase/helpers";

export const getProjects = () => {
  return async (dispatch) => {
    dispatch({ type: "GET_PROJECTS_START" });
    try {
      const snapshot = await getDocs(
        query(collection(db, "products"), orderBy("createdAt", "desc"))
      );
      const payload = snapshot.docs
        .map(normalizeProduct)
        .filter((item) => item.is_active !== false);

      dispatch({ type: "GET_PROJECTS_SUCCESS", payload });
    } catch (error) {
      dispatch({
        type: "GET_PROJECTS_ERROR",
        payload: error?.message || "تعذر تحميل المنتجات",
      });
    }
  };
};

export const getCategories = () => {
  return async (dispatch) => {
    dispatch({ type: "GET_CATEGORIES_START" });
    try {
      const snapshot = await getDocs(
        query(collection(db, "categories"), orderBy("sort_order", "asc"))
      );
      const payload = snapshot.docs
        .map(normalizeCategory)
        .filter((item) => item.is_active !== false);

      dispatch({ type: "GET_CATEGORIES_SUCCESS", payload });
    } catch (error) {
      dispatch({
        type: "GET_CATEGORIES_ERROR",
        payload: error?.message || "تعذر تحميل التصنيفات",
      });
    }
  };
};

export const getNews = () => {
  return async (dispatch) => {
    dispatch({ type: "GET_NEWS_START" });
    dispatch({ type: "GET_NEWS_SUCCESS", payload: [] });
  };
};